import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {Pagination, Table, message, Image, Select, Button} from 'antd';
import type { ColumnsType } from 'antd/es/table';
import {
  getArticlesApi,
  deleteArticleApi,
  getAllCategoryListApi,
} from "../../../api/ManageApi";
import GlobalLoader from "../../../components/GlobalLoading";
import viewUtils from "../../../utils/viewUtils";

const Article = () => {
  const [categories, setCategories] = useState<any>();
  const [dataList, setDataList] = useState({data: [], total: 0});
  const [filter, setFilter] = useState({
    page: 1,
    per_page: 10,
    category_id: null
  });

  useEffect(() => {
    getAllCategoryListApi().then((res) => {
      if (res.status) {
        setCategories(res?.data?.filter(
          (category: any) => !['about', 'contact'].includes(category?.menu?.page_config?.type)
        ) || [])
      }
    });
  }, []);

  useEffect(() => {
    getArticlesApi({
      page: filter.page || 1,
      per_page: filter.per_page || 10,
      category_id: filter?.category_id || undefined
    }).then((res) => {
      if (res.status) {
        setDataList({
          data: res?.data || [],
          total: res?.paginate?.total_entries || 0
        })
      }
    });
  }, [filter]);

  const handlePageChange = (page: number, per_page: number) => setFilter(data => ({ ...data, page: page, per_page: per_page }));

  const handleArticleDelete = (article: any) => {
    GlobalLoader.show();
    deleteArticleApi(article?.id || 0).then((res) => {
      if (res.status) {
        setFilter(data => ({...data }))
      } else {
        message.error(res?.error || '')
      }
      GlobalLoader.hide();
    })
  }

  const columns: ColumnsType<any> = [
    {
      title: "ID",
      key: 'id',
      width: 100,
      render: (r) => r?.id
    },
    {
      title: "分类",
      key: 'category',
      width: 200,
      render: (r) => viewUtils.showCategoryName(r?.category)
    },
    {
      title: "名称",
      key: 'name',
      width: 200,
      render: (r) => <>
        {!!r?.name?.zh && <div>{`中文：${r?.name?.zh}`}</div>}
        {!!r?.name?.en && <div>{`英文：${r?.name?.en}`}</div>}
        {!!r?.name?.ja && <div>{`日文：${r?.name?.ja}`}</div>}
      </> || ""
    },
    {
      title: "日期",
      key: 'date',
      width: 150,
      render: (r) => r.date
    },
    {
      title: "封面",
      key: 'assets_url',
      width: 200,
      render: (r) => <>
        {
          ['zh', 'en', 'ja'].map(key => (
            <div key={key}>
              {
                !!((r.assets_url || {})[key] || [])[0] ? <>
                  {key}:
                  <Image
                    src={((r.assets_url || {})[key] || [])[0]}
                    preview={true}
                    style={{
                      width: "150px",
                    }}
                  />
                </> : <></>
              }
            </div>
          ))
        }
      </>
    },
    {
      title: "排序权重",
      key: 'sequence',
      width: 100,
      render: (r) => r.sequence
    },
    {
      title: "操作",
      key: 'actions',
      width: 150,
      fixed: 'right',
      render: (r) => <>
        <NavLink to={`/system_manage/article/info/${r.id}`}><Button type='link' size='small'>编辑</Button></NavLink>
        <Button type='link' danger size='small' onClick={() => handleArticleDelete(r)}>删除</Button>
      </>
    }
  ]

  return <>
    <div style={{display: "flex", justifyContent: 'space-between', marginBottom: '1em'}}>
      <Select
        style={{ minWidth: 'min(50vw, 30em)' }}
        options={[
          { label: '全部', value: '' },
          ...((categories || []).map((category: any) => ({
            label: viewUtils.showCategoryName(category),
            value: category.id
          })))
        ]}
        onChange={(e) => setFilter(data => ({ ...data, page: 1, category_id: e }))}
      />
      <NavLink to={`/system_manage/article/create`}>
        <Button type='primary'>创建</Button>
      </NavLink>
    </div>
    <div>
      <Table
        size='small'
        scroll={{ x: 1100, scrollToFirstRowOnChange: true }}
        pagination={false}
        rowKey={r => r.id}
        columns={columns}
        dataSource={dataList.data}
      />
      <Pagination
        showTotal={(total) => `共${total}个`}
        current={filter.page}
        pageSize={filter.per_page}
        total={dataList.total}
        onChange={handlePageChange}
        showSizeChanger={false}
        hideOnSinglePage={false}
        style={{textAlign: 'right', justifyContent: 'flex-end', margin: '1em 0'}}
      />
    </div>
  </>;
};

export default Article;